module.exports = __webpack_public_path__ + "media/super6_bppair.d6a57f50.mp3";